{
	"language": {
		"aria": "Mainīt valodu"
	},
	"placeholder": {
		"title": "Jūsu kandidāta centrs jau tiek gatavots",
		"body": "Pagaidām šeit vēl nekā nav. Kad viss būs gatavs, nosūtīsim jums saiti pa e-pastu."
	},
	"not_found": {
		"title": "Lapa nav atrasta",
		"body": "Pārbaudiet saiti, kuru izmantojāt, vai izmantojiet saiti no sava e-pasta."
	},
	"error_boundary": {
		"reload": "Pārlādēt lapu"
	},
	"login": {
		"loading": "Ielādē…",
		"title": "Pierakstieties savā kandidāta centrā",
		"intro": "Ievadiet savu e-pasta adresi, lai apskatītu savus pieteikumus.",
		"email_label": "E-pasta adrese",
		"email_placeholder": "jus@piemers.lv",
		"submit": "Pieteikties",
		"sending": "Sūta…",
		"sent": {
			"title": "Pārbaudiet savu e-pastu",
			"body": "Ja {{email}} atbilst kādam pieteikumam, pierakstīšanās saite jau ir ceļā.",
			"retry": "Nesaņēmāt to? Pārbaudiet adresi un mēģiniet vēlreiz"
		},
		"resent": {
			"title": "Mēs jums nosūtījām jaunu pierakstīšanās saiti",
			"body": "Jūsu atvērtās saites derīguma termiņš ir beidzies. Ja jūsu e-pasts atbilst kādam pieteikumam, jauna pierakstīšanās saite jau ir ceļā. Tā atvērs to pašu lapu.",
			"request_manually": "Nesaņēmāt to? Pieprasiet jaunu saiti"
		},
		"request_error": {
			"throttled": "Pārāk daudz mēģinājumu. Lūdzu, uzgaidiet minūti un mēģiniet vēlreiz.",
			"invalid_email": "Lūdzu, ievadiet derīgu e-pasta adresi.",
			"generic": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz."
		},
		"unknown_organisation": {
			"title": "Lapa nav atrasta",
			"body": "Pārbaudiet saiti, kuru izmantojāt, vai izmantojiet saiti no sava e-pasta."
		},
		"error": {
			"title": "Kaut kas nogāja greizi",
			"body": "Neizdevās ielādēt šo lapu. Lūdzu, mēģiniet vēlreiz pēc brīža."
		}
	},
	"organisations": {
		"title": "Jūsu pieteikumi",
		"intro": "Izvēlieties uzņēmumu, lai apskatītu tam nosūtītos pieteikumus.",
		"count_zero": "{{count}} pieteikumu",
		"count_one": "{{count}} pieteikums",
		"count_other": "{{count}} pieteikumi",
		"empty": {
			"title": "Pagaidām nav pieteikumu",
			"body": "Kad piesakāties uzņēmumā, tas parādīsies šeit."
		},
		"error": "Neizdevās ielādēt jūsu uzņēmumus. Lūdzu, mēģiniet vēlreiz pēc brīža.",
		"log_out": "Iziet",
		"logging_out": "Iziet…"
	},
	"submissions": {
		"title": "Iepriekšējie pieteikumi",
		"back_to_organisations": "Visi uzņēmumi",
		"cv_uploaded": "CV augšupielādēts",
		"empty": {
			"title": "Pagaidām nav pieteikumu",
			"body": "Pieteikumi, ko nosūtāt uzņēmumam {{organisation}}, parādīsies šeit."
		},
		"error": "Neizdevās ielādēt jūsu pieteikumus. Lūdzu, mēģiniet vēlreiz pēc brīža.",
		"log_out": "Iziet",
		"logging_out": "Iziet…"
	},
	"profile": {
		"link": {
			"title": "Jūsu profils",
			"cv_added": "CV pievienots",
			"cv_missing": "Vēl nav CV"
		},
		"back": "Atpakaļ uz pieteikumu",
		"context": "{{campaign}} · {{organisation}}",
		"contact_consent": "Jūs piekrītat, ka ar jums sazinās par šo darba vietu.",
		"cv": {
			"title": "CV",
			"upload": {
				"title": "Augšupielādējiet savu CV",
				"drop_hint": "vai velciet un nometiet to šeit",
				"constraints": "{{types}}, līdz {{size}} MB",
				"uploading": "Augšupielādē {{fileName}}…",
				"done": "CV augšupielādēts",
				"error_type": "Šis faila tips netiek atbalstīts. Atļautie tipi: {{types}}.",
				"error_size": "Fails ir pārāk liels. Maksimālais izmērs ir {{size}} MB."
			},
			"remove": {
				"label": "Noņemt {{fileName}}",
				"question": "Noņemt {{fileName}}?",
				"consequence": "Darba devējs to vairs neredzēs. Šo darbību nevar atsaukt.",
				"confirm": "Noņemt CV",
				"cancel": "Atcelt",
				"removing": "Noņem…",
				"error": "Neizdevās noņemt jūsu CV. Mēģiniet vēlreiz."
			}
		},
		"work_history": {
			"title": "Darba pieredze",
			"description": "Pastāstiet mums par savu atbilstošo darba pieredzi: kur strādājāt, ko tur darījāt un cik ilgi tur strādājāt. Varat pievienot vairāk nekā vienu darba vietu, ja tās ir atbilstošas.",
			"placeholder": "Aprakstiet darbu, ko esat strādājis",
			"input_label": "Darba informācija",
			"save": "Saglabāt",
			"saving": "Saglabā…",
			"cancel": "Atcelt",
			"edit": "Rediģēt",
			"remove": "Noņemt",
			"add_another": "Pievienot vēl vienu darba vietu",
			"error_empty": "Pirms saglabāšanas kaut ko uzrakstiet.",
			"error_limit": "Varat pievienot līdz {{max}} darba vietām.",
			"unsaved_changes": "Jums ir nesaglabātas izmaiņas darba pieredzē. Vai tomēr vēlaties aiziet un tās zaudēt?",
			"hints": {
				"label": "Šī darba informācija",
				"included": "norādīts",
				"missing": "vēl nav norādīts"
			}
		},
		"education": {
			"title": "Izglītība",
			"description": "Pastāstiet mums par savu atbilstošo izglītību: ko mācījāties, kur un kad. Der grādi, skolas, kursi un sertifikāti. Varat pievienot vairāk nekā vienu ierakstu.",
			"placeholder": "Aprakstiet grādu, skolu vai kursu",
			"input_label": "Izglītības informācija",
			"save": "Saglabāt",
			"saving": "Saglabā…",
			"cancel": "Atcelt",
			"edit": "Rediģēt",
			"remove": "Noņemt",
			"add_another": "Pievienot vēl vienu izglītību",
			"error_empty": "Pirms saglabāšanas kaut ko uzrakstiet.",
			"error_limit": "Varat pievienot līdz {{max}} izglītības ierakstiem.",
			"unsaved_changes": "Jums ir nesaglabātas izmaiņas izglītībā. Vai tomēr vēlaties aiziet un tās zaudēt?"
		},
		"licenses": {
			"title": "Apliecības un sertifikāti",
			"description": "Pastāstiet mums par savām apliecībām un sertifikātiem, piemēram, vadītāja apliecību, iekrāvēja vadītāja apliecību vai higiēnas apliecību. Norādiet, kad to saņēmāt un kad beidzas tās derīgums, ja tāds ir. Varat pievienot vairāk nekā vienu ierakstu.",
			"placeholder": "Aprakstiet apliecību vai sertifikātu",
			"input_label": "Apliecības informācija",
			"save": "Saglabāt",
			"saving": "Saglabā…",
			"cancel": "Atcelt",
			"edit": "Rediģēt",
			"remove": "Noņemt",
			"add_another": "Pievienot vēl vienu apliecību",
			"error_empty": "Pirms saglabāšanas kaut ko uzrakstiet.",
			"error_limit": "Varat pievienot līdz {{max}} apliecībām.",
			"unsaved_changes": "Jums ir nesaglabātas izmaiņas apliecībās. Vai tomēr vēlaties aiziet un tās zaudēt?"
		}
	},
	"submission": {
		"back": "Atpakaļ uz maniem pieteikumiem",
		"back_short": "Atpakaļ",
		"not_found": {
			"title": "Pieteikums nav atrasts",
			"body": "Šis pieteikums neeksistē vai nav jūsu pieteikums."
		},
		"result": {
			"heading": "Apstiprinājuma ekrāns, ko redzējāt pēc pieteikšanās"
		},
		"summary": {
			"title": "Jūsu atbilžu kopsavilkums",
			"submitted_on": "Šo veidlapu iesniedzāt",
			"submitted_more_than_once": "Šo veidlapu aizpildījāt vairāk nekā vienu reizi. Mēs automātiski apvienosim jūsu profilu; zemāk redzamais pieteikums ir jaunākais."
		}
	}
}
